import { Interpolation, Theme } from '@emotion/react';
import { i18next } from '@frontend/i18n';
import { SettingsRoutes } from '@frontend/settings-routing';

export const AiReceptionistSettingsRoutes: Record<string, SettingsRoutes> = {
  ROOT: '/ai-configuration/ai-receptionist',
  AI_RECEPTIONIST: '/ai-configuration/ai-receptionist/ai-receptionist',
  BUSINESS_PREFERENCES: '/ai-configuration/ai-receptionist/business-preferences',
  BUSINESS_PROFILE: '/ai-configuration/ai-receptionist/business-preferences/business-profile',
  ADVANCED: '/ai-configuration/ai-receptionist/business-preferences/advanced',
  AMENITIES: '/ai-configuration/ai-receptionist/business-preferences/amenities',
  BEFORE_AFTER_APPOINTMENT: '/ai-configuration/ai-receptionist/business-preferences/before-after-appointment',
  HIDDEN_PREFERENCES: '/ai-configuration/ai-receptionist/business-preferences/hidden-preferences',
  INSURANCE: '/ai-configuration/ai-receptionist/business-preferences/insurance',
  MISSED_CALLS: '/ai-configuration/ai-receptionist/business-preferences/missed-calls',
  NOTIFICATIONS: '/ai-configuration/ai-receptionist/business-preferences/notifications',
  PHARMACY_RECORDS: '/ai-configuration/ai-receptionist/business-preferences/pharmacy-records',
  SCHEDULING: '/ai-configuration/ai-receptionist/business-preferences/scheduling',
  ONLINE_BOOKING: '/ai-configuration/ai-receptionist/online-booking',
  PATIENT_BILLING: '/ai-configuration/ai-receptionist/business-preferences/patient-billing',
  SCHEDULE_SERVICES: '/schedule/services',
  SCHEDULE_AVAILABILITY: '/schedule/availability',

  WEB_TO_TEXT: '/ai-configuration/ai-receptionist/web-to-text',

  INSTRUCTIONS_MESSAGING_VOICE: '/ai-configuration/ai-receptionist/instructions/messaging-voice',
  INSTRUCTIONS_SCHEDULING: '/ai-configuration/ai-receptionist/instructions/scheduling',
  KNOWLEDGE_BASE_BUSINESS: '/ai-configuration/ai-receptionist/knowledge-base/business',
  KNOWLEDGE_BASE_PAYMENTS: '/ai-configuration/ai-receptionist/knowledge-base/payments',
  KNOWLEDGE_BASE_SCHEDULE: '/ai-configuration/ai-receptionist/knowledge-base/schedule',
  KNOWLEDGE_BASE_CUSTOM: '/ai-configuration/ai-receptionist/knowledge-base/custom',
};

export const MAX_LENGTH_TEXTAREA = 160;
export const MAX_LENGTH_TEXTAREA_EXTENDED = 200;

export const airSettingTextAreaStyles: Interpolation<Theme> = {
  textAlign: 'right', // To show char count in helper text on end of the textarea
};
export const CHARACTER_LIMIT_ERROR = (maxLength: number) =>
  i18next.t('Cannot exceed {{maxLength}} characters', {
    maxLength,
    ns: 'ai-receptionist-settings',
  });

export const URL_ERROR_VALIDATION = 'Please enter a valid URL starting with http:// or https://';

export const DAYS_OF_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// Reverse mapping from form day names to API day names
export const FORM_TO_API_DAY_MAPPING: Record<string, string> = {
  monday: 'MONDAY',
  tuesday: 'TUESDAY',
  wednesday: 'WEDNESDAY',
  thursday: 'THURSDAY',
  friday: 'FRIDAY',
  saturday: 'SATURDAY',
  sunday: 'SUNDAY',
};

export const DAY_MAPPING: Record<string, string> = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
};

export const DEFAULT_WORKING_HOURS_RANGE = {
  value: ['09:00:00', '17:00:00'],
  displayValue: ['9:00am', '5:00pm'],
};

export const AIR_COHORT = {
  BRIDGELINE: 'bridgeline',
  STEELTHREAD: 'steelthread',
} as const;
